import { createRef } from 'react';
import Form from '@rjsf/core';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import ImageRadioWidget from './CustomFIelds/RadioWidget';
import ColorSelectWidget from './CustomFIelds/ColorWidget';
import { useFormStore } from '../../state/FormStore';
import UnderConstruction from './CustomFIelds/UnderConstruction';
import { t } from '../../utils/i18n';


const formRef = createRef();
const schema: RJSFSchema = {
    type: 'object',

    "properties": {

        "voorkant_alum_schuifdeur_options": {
            type: 'object',
            title: t('Aluminium_schuifdeur'),
            properties: {
                voorkant_schuifdeur_handle: {
                    type: 'string',
                    title: t('Handle'),
                    default: 'Rechts',
                    enum: [
                        'Rechts', 'Links'
                    ], // Add your image options here
                    enumNames: [t('Rechts'), t('Links')],
                },

            },
        },
        "rechter_alum_schuifdeur_options": {
            type: 'object',
            title: t('Aluminium_schuifdeur'),
            properties: {
                rechter_schuifdeur_handle: {
                    type: 'string',
                    title: t('Handle'),
                    default: 'Rechts',
                    enum: [
                        'Rechts', 'Links'
                    ], // Add your image options here
                    enumNames: [t('Rechts'), t('Links')],
                },

            },
        },
        "linker_alum_schuifdeur_options": {
            type: 'object',
            title: t('Aluminium_schuifdeur'),
            properties: {
                linker_schuifdeur_handle: {
                    type: 'string',
                    title: t('Handle'),
                    default: 'Rechts',
                    enum: [
                        'Rechts', 'Links'
                    ], // Add your image options here
                    enumNames: [t('Rechts'), t('Links')],
                },

            },
        },
        "voorkant_glazen_schuifdeur_options": {
            type: 'object',
            title: t('Glass Type'),
            properties: {
                glazen_schuifdeur_type: {
                    type: 'string',
                    title: t('Glass Type'),
                    default: 'Helder Glas',
                    enum: ['Helder Glas', 'Getint Glas'],
                    enumNames: [t('Helder Glas'), t('Getint Glas')],
                },
            },
        },
    }
};


const uiSchema = {
    'ui:classNames': 'sub-darzo-input',
    voorkant_alum_schuifdeur_options: { // Correct placement of custom widget

        voorkant_schuifdeur_handle: { // Place the custom widget under kleur_option
            'ui:widget': 'ImageRadioWidget', // Correct path to custom widget
        }
    },
    rechter_alum_schuifdeur_options: { // Correct placement of custom widget

        rechter_schuifdeur_handle: { // Place the custom widget under kleur_option
            'ui:widget': 'ImageRadioWidget', // Correct path to custom widget
        }
    },
    linker_alum_schuifdeur_options: { // Correct placement of custom widget

        linker_schuifdeur_handle: { // Place the custom widget under kleur_option
            'ui:widget': 'ImageRadioWidget', // Correct path to custom widget
        }
    },
    voorkant_glazen_schuifdeur_options: {
        glazen_schuifdeur_type: {
            'ui:widget': 'ImageRadioWidget',
        }
    },

};


const widgets = {
    ImageRadioWidget: ImageRadioWidget,
    ColorSelectWidget: ColorSelectWidget,
    UnderConstruction: UnderConstruction,
};

const onError = (errors) => alert(errors);


export const SubConfigurationForm = () => {
    const { formData, setFormData } = useFormStore();
    const activeTab = useFormStore(state => state.activeTab);

    // Dynamically build schema and uiSchema
    let dynamicSchema = { type: 'object', properties: {} };
    let dynamicUiSchema = { 'ui:classNames': 'sub-darzo-input' };

    if (activeTab === 'voorkant' && formData?.voorkant?.schuifdeur === 'Aluminium Schuifdeur' && formData?.maat?.breedte <= 400) {
        dynamicSchema.properties.voorkant_alum_schuifdeur_options = schema.properties.voorkant_alum_schuifdeur_options;
        dynamicUiSchema.voorkant_alum_schuifdeur_options = uiSchema.voorkant_alum_schuifdeur_options;
    }
    if (activeTab === 'voorkant' && formData?.voorkant?.schuifdeur === 'Glazen Schuifdeur') {
        dynamicSchema.properties.voorkant_glazen_schuifdeur_options = schema.properties.voorkant_glazen_schuifdeur_options;
        dynamicUiSchema.voorkant_glazen_schuifdeur_options = uiSchema.voorkant_glazen_schuifdeur_options;
    }
    if (activeTab === 'rechter' && formData?.rechter?.rechter_wand_option === 'Aluminium Schuifdeur' && formData?.maat?.uitval <= 400) {
        dynamicSchema.properties.rechter_alum_schuifdeur_options = schema.properties.rechter_alum_schuifdeur_options;
        dynamicUiSchema.rechter_alum_schuifdeur_options = uiSchema.rechter_alum_schuifdeur_options;
    }
    if (activeTab === 'linker' && formData?.linker?.linker_wand_option === 'Aluminium Schuifdeur' && formData?.maat?.uitval <= 400) {
        dynamicSchema.properties.linker_alum_schuifdeur_options = schema.properties.linker_alum_schuifdeur_options;
        dynamicUiSchema.linker_alum_schuifdeur_options = uiSchema.linker_alum_schuifdeur_options;
    }

    // If nothing matches, don't render the form
    if (Object.keys(dynamicSchema.properties).length === 0) {
        return null;
    }

    const handleChange = ({ formData, errors }) => {
        // Check if there are any errors
        if (errors && errors.length > 0) {
            // Handle errors here, such as displaying them to the user
            console.error('Form errors:', errors);
        } else {
            // Get the existing form data from the store
            const existingFormData = useFormStore.getState().formData;

            // Merge the new form data with the existing form data
            const updatedFormData = {
                ...existingFormData,
                ...formData
            };

            // Update form data in the store
            setFormData(updatedFormData);
            //console.log(useFormStore.getState().formData);

            // Optionally, perform any additional calculations or operations
            // const calculator = new VerandaCalculator(transformFormData(updatedFormData));
            // console.log(calculator.calculateAllProfiles());
        }
    };


    return (
        <div>
            <Form
                schema={dynamicSchema}
                uiSchema={dynamicUiSchema}
                widgets={widgets}
                onChange={handleChange}
                /*     formData={formData} */
                onSubmit={(data) => console.log('Data submitted:', data)}
                validator={validator}
                onError={onError}
                ref={formRef}
                liveValidate={true}
            />
        </div>
    );
};

